import { render, staticRenderFns } from "./SectionCardTitle.vue?vue&type=template&id=f039bd4c&scoped=true&"
import script from "./SectionCardTitle.vue?vue&type=script&lang=js&"
export * from "./SectionCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./SectionCardTitle.vue?vue&type=style&index=0&id=f039bd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f039bd4c",
  null
  
)

export default component.exports